var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"widget widget-checkbox",attrs:{"data-field":_vm.fieldName,"id":_vm.fieldName}},[_c('input',{class:[_vm.autoWidth ? 'auto-width' : '', _vm.readOnly ? 'readOnly' : ''],attrs:{"type":"checkbox","disabled":!_vm.editable},domProps:{"checked":_vm.value},on:{"change":_vm.onChange}})])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-2f54eac8","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/questionnaires/widgets/CheckboxWidget.vue
// module id = /D84
// module chunks = 1